<script>
  import FetchController from './FetchController.vue';
  export default {
    extends: FetchController,
    methods: {
      getAllUser(job) {
        return this.fetchData(`/users/get-all?job=${job}`, 'GET', null, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      updateUser(changeArr) {
        return this.fetchData('/users/update-user-role', 'POST', JSON.stringify({changeArr}), true, true)
          .then(res => {
            if(res.ok) {
              return
            }
            return res.json();
          })
          .then(data => {
            if(data === undefined) {
              return new Promise((resolve) => {
                resolve({status: 201})
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 400, msg: data.msg})
              })
            }
          })
      },
      deleteUser(id) {
        return this.fetchData('/users/delete-account', 'DELETE', {id}, true, false)
          .then(res => {
            if(res.ok) {
              return
            }
            return res.json();
          })
          .then(data => {
            if(data === undefined) {
              return new Promise((resolve) => {
                resolve({status: 204})
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 400, msg: data.msg})
              })
            }
          })
      },
      resetPassword(id) {
        return this.fetchData('/users/reset-password', 'PUT', {id}, true, false)
          .then(res => {
            if(res.ok) {
              return
            }
            return res.json();
          })
          .then(data => {
            if(data === undefined) {
              return new Promise((resolve) => {
                resolve({status: 204})
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 400, msg: data.msg})
              })
            }
          })
      }
    }
  }
</script>